// 行情相关接口

import Vue from 'vue'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import getLocalFixedQuoteDetail from 'utils/getLocalFixedQuoteDetail'
import getOptionExpiryStamp from 'utils/getOptionExpiryStamp'

/**
 * 获取股票详情
 * @param {object} data - 请求参数
 * @param {object} options - 请求补充参数（如取消请求逻辑）
 */
export function getQuoteDetail(data, options) {
  const params = {
    symbol: data.symbol,
    market: data.market,
    secType: data.secType
  }
  if (params.secType === SEC_TYPE.OPT) {
    Object.assign(params, {
      expiry: getOptionExpiryStamp(data.expiry),
      right: data.right,
      strike: data.strike
    })
    return Vue.http
      .get(`~option/option/quote/${params.symbol}`, {
        params,
        ...options
      })
      .then(({ data: detail }) => {
        detail.secType = SEC_TYPE.OPT
        detail.market = MARKET_TYPE.US
        return getLocalFixedQuoteDetail(detail)
      })
  }
  if (params.market === MARKET_TYPE.US) {
    return Vue.http
      .get('~stock/stock_info/detail/{symbol}', {
        params,
        ...options
      })
      .then(({ data: res }) => {
        if (res.ret === 0 && res.items && res.items.length) {
          const detail = res.items[0]
          detail.serverTime = res.serverTime
          detail.secType = SEC_TYPE.STK
          detail.market = MARKET_TYPE.US
          return getLocalFixedQuoteDetail(detail)
        }
      })
  }
  if (params.market === MARKET_TYPE.HK) {
    return Vue.http
      .get('~stock/hkstock/stock_info/detail/{symbol}', {
        params,
        ...options
      })
      .then(({ data: res }) => {
        if (res.ret === 0 && res.items && res.items.length) {
          const detail = res.items[0]
          detail.serverTime = res.serverTime
          detail.secType = SEC_TYPE.STK
          detail.market = MARKET_TYPE.HK
          return getLocalFixedQuoteDetail(detail)
        }
      })
  }
}

/**
 * 获取盘前盘后信息（仅支持美股）
 * @param {string} params.symbol
 * @param {number} [params.beginTime] - 开始时间
 *
 * @return {object} {symbol, preClose, items, detail}
 */
export function getHourTradingTrend(params) {
  return Vue.http
    .get(`~stock/stock_info/time_trend/hour_trading/${params.symbol}`, {
      params
    })
    .then(res => {
      if (res.data.ret === 0) {
        return res.data
      }
      throw res.data
    })
}
